<template>
  <b-form @submit.prevent="save">
    <b-form-group label="Name:">
      <b-form-input
        type="text"
        autofocus
        v-model.trim="$v.displayName.$model"
        :class="{ 'is-invalid': $v.displayName.$error }"
        autocomplete="off"
        :disabled="inPorcess"
      />
      <b-form-invalid-feedback v-if="!$v.displayName.required">Display Name is required</b-form-invalid-feedback>
      <b-form-invalid-feedback
        v-if="!$v.displayName.isUnique"
      >Column with the same name already exists</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Table to lookup:">
      <b-form-select
        v-model="$v.lookUpTable.$model"
        :class="{ 'is-invalid': $v.lookUpTable.$error }"
        :options="availableGrids"
        :disabled="inPorcess"
      />
      <b-form-invalid-feedback v-if="!$v.lookUpTable.required">Table to lookup is required</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-if="lookUpTable && instanceNotCreated">
      <b-form-checkbox v-model="addDataGridInstance">
        <span style="vertical-align: 0px;">Add A Table To The Parent Form</span>
      </b-form-checkbox>
    </b-form-group>
    <b-button variant="success" type="submit">Save</b-button>
  </b-form>
</template>

<script>
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: [
    'type',
    'gridId',
    'rowIndex',
    'sectionIndex'
  ],
  data() {
    return {
      inPorcess: false,
      displayName: null,
      lookUpTable: null,
      addDataGridInstance: true,
    }
  },
  computed: {
    ...mapState(['dataGrid_options']),
    availableGrids() {
      const grids = []

      for (let gridId in this.dataGrid_options) {
        grids.push({
          text: this.dataGrid_options[gridId].title,
          value: gridId,
        })
      }

      return grids
    },
    instanceNotCreated() {
      if (!this.dataGrid_options[this.gridId].meta) return true
      if (!this.lookUpTable) return true

      return this.dataGrid_options[this.gridId].meta[`${this.lookUpTable}_instance`] ? false : true
    },
    needToAddInstance() {
      if (!this.instanceNotCreated) return false
      if (!this.addDataGridInstance) return false
      return true
    },
  },
  methods: {
    async save() {
      if (this.inPorcess) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inPorcess = true

      const data = {
        type: this.type,
        gridId: this.gridId,
        displayName: this.displayName,
        propertyName: this.$sanitize(this.displayName),
        lookUpTable: this.lookUpTable,
      }

      await db.dataGrid.data.addColumn(data)

      if (this.instanceNotCreated && this.addDataGridInstance) {
        const data = {
          type: 'datagrid',
          gridId: this.lookUpTable,
          displayName: this.dataGrid_options[this.gridId].title,
          propertyName: `${this.lookUpTable}_instance`,
          dataGrid: this.gridId,
          filterColumn: this.$sanitize(this.displayName),
        }

        eventBus.$emit('addDataGridInstance', data)
      }

      this.$store.commit('dataGrid_setLogsValue', {
        type: 'ColChange',
        newVal: data.displayName,
        gridId: data.gridId,
      })

      this.inPorcess = false
      this.displayName = null
      this.lookUpTable = null
      this.addDataGridInstance = true
      this.$nextTick(() => {
        this.$v.$reset()
      })

      this.$emit('submitted')
    }
  },
  validations: {
    displayName: {
      required,
      isUnique(value) {
        if (!value) return true

        for (let cellKey in this.dataGrid_options[this.gridId].meta) {
          if (this.$sanitize(value) === cellKey) return false
        }

        return true
      },
    },
    lookUpTable: {
      required,
    },
  },
}
</script>
